import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { requestPasswordReset } from "@/services/student/password.service";
import { useAppToast } from "@/hooks/useAppToast";

interface ChangePasswordFormProps {
  userEmail?: string;
}

export const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({ userEmail }) => {
  const toast = useAppToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!userEmail) {
      toast.error("Email não encontrado. Por favor, atualize seu perfil primeiro.");
      return;
    }

    setIsSubmitting(true);
    try {
      await requestPasswordReset(userEmail);
      toast.success(
        "Link de redefinição de senha enviado! Verifique seu email."
      );
    } catch (error: any) {
      console.error("Error requesting password reset:", error);
      toast.error(
        error?.response?.data?.message ||
          "Erro ao solicitar redefinição de senha"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Alterar Senha</CardTitle>
        <CardDescription>
          Um link de redefinição de senha será enviado para o email cadastrado: <strong>{userEmail || "Não disponível"}</strong>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex justify-end">
            <Button type="submit" disabled={isSubmitting || !userEmail}>
              {isSubmitting ? "Enviando..." : "Enviar link de redefinição"}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};
